import Image from 'Components/Image';

interface LogoProps extends Partial<HTMLImageElement> {
  id: string;
  alt : string;
}

export default function Logo({ id, alt }: LogoProps) {
  const src = `https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/${id}/logo.png`;

  return (
    <Image {...{ src, alt }} />
  );
}
